var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntuitiveNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8f8f8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.33 6.12 26.06 .44 22.78 6.12 25.64 6.12 25.64 12.47 26.47 12.47 26.47 6.12 29.33 6.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.57 13.96 33.89 10.68 33.89 13.55 27.54 13.55 27.54 14.37 33.89 14.37 33.89 17.24 39.57 13.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.51 10.68 11.83 13.96 17.51 17.24 17.51 14.37 23.86 14.37 23.86 13.55 17.51 13.55 17.51 10.68"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.21,33.52c1.82-1.31,3.83-.38,6.96,2.77.5-2.32.22-4.41.27-6.45.07-3.18-.07-6.36.12-9.53.16-2.61,1.64-4.08,3.65-4.11,2.02-.03,3.38,1.41,3.74,4.01.1.75-.1,2.85-.04,3.88,1.41-1.68,4.67-.35,5.49,2.29,3.53-.34,5.16,1.58,5.51,4.68,4.44.88,5.06,1.6,5.1,5.81.03,2.8-.06,5.6.02,8.39.08,2.71-.15,5.35-1.47,7.77-1.1,2.01-.51,4.5-1.8,6.75-2.16-1.82-1.3-3.9-.64-5.37,2.51-5.61,1.7-11.48,1.8-17.28.02-1.35.25-2.87-1.31-3.72-3.3.16-.75,4.01-3.18,4.91-2.03-2.91.2-6.54-1.53-9.4-.82-.35-1.54-.39-2.1.26-1.2,1.74.37,4.1-1.5,5.97-2.27-3-.02-6.64-1.75-9.37-.85-.42-1.55-.41-2.29.43-.97,3.03.56,6.58-1.02,9.99-1.68-.86-1.4-2.21-1.41-3.36-.05-3.69,0-7.37-.04-11.06-.01-1.33.29-2.86-1.39-3.55-2.23.51-1.75,2.28-1.76,3.69-.05,5.21.02,10.43-.04,15.64-.02,1.32.51,2.82-.94,3.99-3.28-1.14-3.04-6.91-7.55-6.49-1.11,1.59-.31,2.59.29,3.49,3.28,4.89,5.78,12.82,8.79,17.84.96,1.6,0,1.42-1.67,3.61-2.43-7.74-5.75-14.68-9.34-21.51-.89-1.69-.52-3.86,1.03-4.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntuitiveNavigation);
export default __webpack_public_path__ + "static/media/Intuitive Navigation.abc038e20e5cfba440b6e8e9135292da.svg";
export { ForwardRef as ReactComponent };